import useFunctionInfo from "@/Hooks/useDataInformation/useFunctionInfo";
import type { MHome } from "@/Models/MHome/MHome";
import { useEffect, useState } from "react";

const STORAGE_KEY = "homeDataHooksCache";
const CACHE_TTL = 60 * 60 * 1000; // 1 hora en milisegundos

type CacheItem<T> = {
  data: T;
  timestamp: number;
};

export const useHomeInformation = () => {
  const { data: HomeInformation, loading: Islogins } =
    useFunctionInfo<MHome[]>("/HomeInformation");

  const [homeData, setHomeData] = useState<MHome[]>([]);
  const [isLogin, setIsLogin] = useState<boolean>(true);

  useEffect(() => {
    const storedItem = localStorage.getItem(STORAGE_KEY);
    if (storedItem) {
      try {
        const parsed = JSON.parse(storedItem) as CacheItem<MHome[]>;
        const isExpired = Date.now() - parsed.timestamp > CACHE_TTL;
        if (!isExpired && parsed?.data && parsed.data?.length > 0) {
          setHomeData(parsed?.data);
          setIsLogin(false);
        } else {
          localStorage.removeItem(STORAGE_KEY);
        }
      } catch (error) {
        console.warn("Error parsing cache:", error);
        localStorage.removeItem(STORAGE_KEY);
      }
    }

    if (Array.isArray(HomeInformation) && !Islogins) {
      setHomeData(HomeInformation);
      setIsLogin(false);
    }
  }, [HomeInformation, Islogins]);

  return {
    homeData,
    isLoading: Islogins || isLogin,
  };
};
